// exp_PORTFOLIO-61587_file
import { FC, useRef } from 'react';

import { ElementShownAnchor } from '@hh.ru/analytics-js';
import vacancyOfTheDayFormElementShown from '@hh.ru/analytics-js-events/build/clickme/employer/campaign_menu/vacancy_of_the_day/vacancy_of_the_day_form_element_shown';
import { GridColumn, GridLayout, GridRow, useBreakpoint, VSpacing, VSpacingContainer } from '@hh.ru/magritte-ui';

import { StickyActionBarWrapper } from 'components/common/StickyActionBarWrapper/StickyActionBarWrapper';
import { Areas } from 'components/VacancyOfTheDayBuilder/components/Areas';
import { ExamplesCarousel } from 'components/VacancyOfTheDayBuilder/components/ExamplesCarousel';
import { ForecastCard } from 'components/VacancyOfTheDayBuilder/components/ForecastCard';
import { MobileBanner } from 'components/VacancyOfTheDayBuilder/components/MobileBanner';
import { Presets } from 'components/VacancyOfTheDayBuilder/components/Presets';
import { ProfessionalRoles } from 'components/VacancyOfTheDayBuilder/components/ProfessionalRoles';
import { UnavailableModal } from 'components/VacancyOfTheDayBuilder/components/UnavailableModal';
import { VacancyOfTheDayActions } from 'components/VacancyOfTheDayBuilder/components/VacancyOfTheDayActions';
import { useVacancyOfTheDayAnalyticsParams } from 'components/VacancyOfTheDayBuilder/useVacancyOfTheDayAnalyticsParams';

export const VacancyOfTheDayBuilder: FC = () => {
    const { isMobile } = useBreakpoint();
    const { params } = useVacancyOfTheDayAnalyticsParams();
    const formShownParams = useRef(params).current;

    return (
        <StickyActionBarWrapper
            content={
                <ElementShownAnchor fn={vacancyOfTheDayFormElementShown} {...formShownParams}>
                    <GridLayout>
                        <GridRow>
                            <GridColumn xs={4} s={8} l={6}>
                                <VSpacingContainer default={32}>
                                    <MobileBanner />
                                    <Areas />
                                    <ProfessionalRoles />
                                    <Presets />
                                    {isMobile && <ForecastCard />}
                                </VSpacingContainer>
                                <VSpacing default={32} />
                            </GridColumn>
                            <GridColumn xs={0} l={2} />
                            <GridColumn xs={0} m={4}>
                                {!isMobile && (
                                    <>
                                        <ForecastCard />
                                        <VSpacing default={12} />
                                        <ExamplesCarousel />
                                        <VSpacing default={32} />
                                    </>
                                )}
                            </GridColumn>
                        </GridRow>
                        <UnavailableModal />
                    </GridLayout>
                </ElementShownAnchor>
            }
            actionBar={<VacancyOfTheDayActions />}
        />
    );
};
